"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasHtml = void 0;
const HTML_TAG = /<\/?[a-z][\s\S]*>/i;
const hasHtml = (text) => HTML_TAG.test(text);
exports.hasHtml = hasHtml;
